import { CircularProgress } from '@mui/material';
import './Loader.css';

const Loader = () => {
  return (
    <div className="loader-overlay">
      <CircularProgress size={40} />
    </div>
  );
};

export default Loader;